import { ProcedimentoAgendaPk } from "../procedimento/procedimento-agenda/pks/procedimento-agenda-pk";
import { Util } from "../util/util";

export class ProcedimentoAgendaDTO {

    idFilial: number | undefined;

    idProcedimento: number | undefined;

    idMedico: number | undefined;

    nomeFilial: string | undefined;

    nomeProcedimento: string | undefined;

    nomeMedico: string | undefined;

    diaSemana: number | undefined;

    horaAtendimento: string | undefined;

    quantidadeAtd: number | undefined;

    tomadas: Array<string> | undefined;

    constructor() {
    }

    get pkProcedimentoAgenda(): ProcedimentoAgendaPk {

        const pk: ProcedimentoAgendaPk = new ProcedimentoAgendaPk();

        if (this.idFilial) {
            pk.idFilial = this.idFilial;
        }

        if (this.idProcedimento) {
            pk.idProcedimento = this.idProcedimento;
        }

        if (this.idMedico) {
            pk.idMedico = this.idMedico;
        }

        if (this.diaSemana) {
            pk.diaSemana = this.diaSemana;
        }

        if (this.horaAtendimento) {
            pk.horaAtendimento = this.horaAtendimento;
        }

        return pk;
    }

    get tomadasFormatadas(): string {

        let tomadaFotmatada: string = '';

        if (this.tomadas) {

            this.tomadas.forEach((currentTomada: any) => {

                tomadaFotmatada = tomadaFotmatada + Util.getHoraFormatada(currentTomada) + ' - ';
            });
        }

        if (tomadaFotmatada && tomadaFotmatada.length > 2) {
            tomadaFotmatada = tomadaFotmatada.substring(0, tomadaFotmatada.lastIndexOf('-') - 1);
        }

        return tomadaFotmatada;
    }

}
